<style scoped>
.btn_shadow {
  background: white 0% 0% no-repeat padding-box;
  box-shadow: 4px 4px 10px #838383, -4px -4px 10px #ffffff !important;
}

.headline {
  background-color: #1b2643;
  width: 100%;
  height: 60px;
}

.content {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}

.active_text {
  border-bottom: 2px solid #ffffff;
  height: 60px;
}

.headline p {
  color: #ffffff;
  font-size: 14px;
}
.title {
  font: normal normal normal 24px/36px Roboto;
}
.filled_noline >>> .v-input__slot::before {
  border-style: none !important;
}
.under-line {
  text-decoration: underline;
}
</style>

<template>
  <div>
    <div class="pa-3 headline">
      <p class="active_text">{{ $t('signOut.signOutTitle') }}</p>
    </div>
    <div class="content pa-10">
      <v-form ref="form">
        <v-row justify="center" class="mt-8">
          <p>{{ $t('signOut.signOutConfirmMessage') }}</p>
        </v-row>
        <v-row justify="center">
          <v-btn
            color="#1b2643"
            class="mb-7 white--text btn_shadow"
            @click="onClickSignOut"
          >
            {{ $t('signOut.signOutTitle') }}
          </v-btn>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "SignOutView",
  data() {
    return {
      //   snackbarAction: false,
    };
  },
  methods: {
    onClickSignOut() {
      // サインアウト
      this.$store.dispatch("signOut");
    },
  },
});
</script>
